import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';

/**
 * Why an administration departed from what was ordered — in its timing or in its amount.
 *
 * Shared by both variances because they answer the same question in different dimensions.
 * Deliberately not statusReason: that means the dose was NOT given, and these record one that was.
 */
export default class AdministrationVariance extends BackboneElement {
    static __className = 'AdministrationVariance';

    __objectStructure = {
        reason: CodeableConcept,
        note: String,
    };

    constructor(constructJson, className = 'AdministrationVariance') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
